import React from "react"
import styled from "styled-components"
import ReactModal from "react-modal"

export const StyledModal = styled(({ className, ...props }) => (
    <ReactModal
        appElement={document.querySelector("#app")}
        className={className}
        overlayClassName={className}
        closeTimeoutMS={200}
        {...props}
    />
))`
    &.ReactModal__Overlay {
        display: grid;
        grid-template-columns: repeat(3, auto);
        grid-template-rows: auto min-content auto;
        grid-gap: 12px;
        grid-template-areas:
            ".      top             ."
            "left   modalContent    right"
            ".      bottom          .";

        justify-content: center;
        align-items: center;

        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 9000; /* Right below sweetalert */

        background-color: rgba(0, 0, 0, 0.2);
        opacity: 0;
        transition: opacity 0.2s;
        will-change: opacity; /* Lets the browser know to expect this rule to change. Use Sparingly! */
    }

    &.ReactModal__Overlay--after-open {
        opacity: 1;
    }

    &.ReactModal__Overlay--before-close {
        opacity: 0;
    }

    &.ReactModal__Content {
        grid-area: modalContent;
        min-height: 100px;
        background-color: white;
        border: 1px solid white;
        border-radius: 4px;
        outline: none;
        padding: 0;
        overflow: hidden;
        webkit-overflow-scrolling: touch;

        animation: showModal 0.2s;
        will-change: transform;
    }

    @keyframes showModal {
        0% {
            transform: scale(0.5);
        }
        45% {
            transform: scale(1.05);
        }
        80% {
            transform: scale(0.95);
        }
        100% {
            transform: scale(1);
        }
    }
`
